export default {
	allowedNameChars: null,
	lang: 'de',
	message: Object,
	ModuleName: '',
	formSubmitted: false,
};
